<nav class="navbar navbar-expand-lg navbar-light transparent">
    <div class="col-6 p-0 d-flex align-items-center">
        <a routerLink="/vyas"> <img src="../../../assets/img/back_button.svg" alt=""></a>
        <a class="mb-0 text-uppercase pl-3 pr-3 d-lg-inline-block title_get">{{getTitle()}}</a>
    </div>


    <div class="col-6 p-0 d-flex align-items-end justify-content-end">
        <div class="dropdown kebab_dropdown ml-3">
            <img src="../../../assets/img/Frame.svg" alt="Kebab" class="img-fluid dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width: 25px;">
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <!-- <a class="dropdown-item" routerLink="/user-profile">USER PROFILE</a> -->
                <!-- <a class="dropdown-item text-uppercase" routerLink="/referral">Refer and earn</a> -->
                <a class="dropdown-item" href="https://ohmassistant.com/faqs" target="_blank">FAQs</a>
                <a class="dropdown-item text-uppercase" href="https://ohmassistant.com/Privacy-Policy-SustLabs" target="_blank">Privacy Policy</a>
                <a class="dropdown-item" aria-disabled="true" style="opacity: 0.5;">VERSION :- {{version}}</a>
                <a class="dropdown-item" (click)="logout()" style="cursor: pointer;">LOGOUT</a>
            </div>
        </div>
    </div>
</nav>